import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';

class LeftNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { musicTitle, musicList },
        } = this.props;

        return (
            <div className={styles.left_box}>
                <Chip id="200148" type="struct" title="有声音乐标题" groupName="有声音乐" content={musicTitle}>
                    <NewsTitle size="middle" />
                </Chip>
                <Chip
                    id="255878"
                    type="recommend"
                    title="有声音乐列表"
                    groupName="有声音乐"
                    content={musicList}
                    translate="handleNewsData">
                    <NewsList hasTitle size="long" />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(LeftNewsBox);
